import { SportConfigExport } from './';
import {
	$t,
	getCompetitorsParams,
	singleStepCompetition,
	singleStepEvent,
	singleStepOverview,
	singleStepTeam,
} from './singleStepContexts';

import { SingleStepSportEvent, SportType } from '@/@types/graphql-types';
import { WebLocale } from '@/enums/web-locale';
import { SportPageType } from '@/features/sports/types/interfaces';

/* CONSTANTS */
const sportName = $t('SPORTS_WEBAPP_SPORT_TYPE_AMERICAN_FOOTBALL');
const switchedLocales = [WebLocale.us, WebLocale.ca, WebLocale.uk];

function getCompetitors(event: SingleStepSportEvent, webLocale: WebLocale) {
	return getCompetitorsParams(event, switchedLocales.includes(webLocale));
}

/* CONTEXTS */
function overview() {
	const { getEventTitleParams, ...rest } = singleStepOverview(SportType.AmericanFootball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		headline: $t('SPORTS_WEBAPP_OVERVIEW_HEADLINE_AMERICAN_FOOTBALL'),
		subheading: $t('SPORTS_WEBAPP_OVERVIEW_TEXT_AMERICAN_FOOTBALL'),
		getCompetitors,
		...singleStepOverview(SportType.AmericanFootball),
		...rest,
	};
}

function competition() {
	const { getEventTitleParams, ...rest } = singleStepCompetition(SportType.AmericanFootball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...singleStepCompetition(SportType.AmericanFootball),
		...rest,
	} as const;
}

function event() {
	const { getEventTitleParams, ...rest } = singleStepEvent(SportType.AmericanFootball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

function team() {
	const { getEventTitleParams, ...rest } = singleStepTeam(SportType.AmericanFootball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

/* EXPORTS */
const config: SportConfigExport = {
	[SportPageType.SportOverview]: overview,
	[SportPageType.SportCompetition]: competition,
	[SportPageType.SportEvent]: event,
	[SportPageType.SportTeam]: team,
};

export default config;
